import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { getCompany } from '../../../core/session-storage/session-storage.service';
import { environment } from '../../../environments/environment';
import { getCodeCompany } from '../../../views/user/user.service';
// import styles from './ea-input.module.scss';

const EaInput = (props: any): ReactElement => {

  const { t } = useTranslation();
  const companyStorage = getCompany();
  const innerHtml =  () => {
    return {__html: t(`${props.inner}`)};
  }

  // WCAG 3.3.1 / 4.1.2: el mensaje de error debe estar asociado al campo mediante
  // aria-describedby, y el campo marcado con aria-invalid.
  const fieldError = props.error?.[props.name]?.isValid === false
    ? props.error[props.name].message
    : (props.error && props.error.isValid === false ? props.error.message : undefined);
  const hasError = Boolean(fieldError);
  const errorId = props.idInput ? `${props.idInput}-error` : undefined;

  return (
    <div data-testid="eaInput" className='ea-input'>
      <div dangerouslySetInnerHTML={props.inner && innerHtml()}></div>
      {!props.isTermsAndConditions && (
        <label htmlFor={props.idInput}> {props.label} </label>
      )}
      {props.isTermsAndConditions && (
        <label htmlFor={props.idInput}>
          {t(`${companyStorage}.baggage_delivery.condicionesLegales_first`)}
            <a href={`${environment.static.pdfs}/${companyStorage}/${props.lang}/CondicionesLegales_${getCodeCompany(companyStorage)}.pdf`} target="_blank" rel="noopener noreferrer">{t(`${companyStorage}.baggage_delivery.condicionesLegales_second`)}</a>
            {t(`${companyStorage}.baggage_delivery.condicionesLegales_third`)}
        </label>
      )}
      <input
       title={props.title}
       id={props.idInput}
       type={props.type}
       value={props.value}
       placeholder={props.placeholder}
       {...props.bindingField}
       name={props.name}
       autoComplete={props.autoComplete || (props.autofill ? 'on' : 'off')}
       aria-invalid={hasError || undefined}
       aria-describedby={hasError ? errorId : undefined}
       data-qa={props.inputDataQa}
      />
       {hasError && <span className="error" id={errorId}>{ t(fieldError) }</span>}
    </div>
  );
};

export default EaInput;
